var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentTagColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g1995",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2001",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1999",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2005",
    transform: "translate(8.616 13.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2007",
    d: "M-70.881-12.154a1.319,1.319,0,0,1,0,1.864,1.316,1.316,0,0,1-1.862,0,1.313,1.313,0,0,1,0-1.864A1.316,1.316,0,0,1-70.881-12.154Z",
    transform: "translate(73.13 12.54)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2009",
    transform: "translate(8.616 6.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2011",
    d: "M-70.881-12.154a1.319,1.319,0,0,1,0,1.864,1.316,1.316,0,0,1-1.862,0,1.313,1.313,0,0,1,0-1.864A1.316,1.316,0,0,1-70.881-12.154Z",
    transform: "translate(73.13 12.54)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2013",
    transform: "translate(14.342 4.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2015",
    d: "M-70.906-12.154a1.319,1.319,0,0,1,0,1.864,1.32,1.32,0,0,1-1.865,0,1.319,1.319,0,0,1,0-1.864A1.32,1.32,0,0,1-70.906-12.154Z",
    transform: "translate(73.156 12.54)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2017",
    transform: "translate(5.742 10.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2019",
    d: "M0-29.36l8.386-.932",
    transform: "translate(0 30.292)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2021",
    transform: "translate(0.615 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2023",
    d: "M-562.06-354.452a6.59,6.59,0,0,0,0-9.319,6.588,6.588,0,0,0-9.318,0l-8.521,8.52,9.318,9.319Z",
    transform: "translate(579.899 365.701)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2025",
    transform: "translate(16.592 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2027",
    d: "M0-119.544l3.792-3.794",
    transform: "translate(0 123.338)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentTagColored);
export default __webpack_public_path__ + "static/media/percent-tag-colored.4e0041a3e92cba14d98b0592b069b3a8.svg";
export { ForwardRef as ReactComponent };